import { Button, Box, Drawer } from "@mui/material";

const STORE_URL = {
  ios: "https://apps.apple.com/kr/app/%EB%A9%94%EA%B0%80%EB%A7%88%ED%8A%B8/id430549569",
  android: "https://play.google.com/store/apps/details?id=com.megamart.mall",
};

export default function UpdatePopup(props) {
  const { open } = props;
  const storeUrl = window.Android ? STORE_URL.android : STORE_URL.ios;

  return (
    <>
      <Drawer
        anchor="bottom"
        open={open}
        className="drawer-common-bottom size-small"
      >
        <div className="drawer-body">
          <div className="box-type-1 align-c">
            <div className="illust">
              <img
                src={`${process.env.PUBLIC_URL}/images/img/illust-warning.svg`}
              />
            </div>
            <p className="text">
              <strong> 업데이트 필요</strong>
            </p>
            <Box component="span" className="count" mt={3}>
              <div className="btm">
                새로운 버전으로의 업데이트가 필요합니다.
                <br />
                업데이트 버튼을 클릭하시면 업데이트
                <br />
                화면으로 이동합니다.
              </div>
            </Box>
          </div>
        </div>
        <div className="drawer-foot">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              window.location.href = `csrmegamart://external-url?${storeUrl}`;
            }}
          >
            업데이트
          </Button>
        </div>
      </Drawer>
    </>
  );
}
